import { WizardPage } from '@app/workflow/components/navigator/wizard-view/interfaces';
import { INavTreeNode } from '@app/workflow/components/navigator/nav-tree/interfaces';
import { SessionItemData } from '@app/workflow/services/session-item-data';

function areChildrenCompleted(current: INavTreeNode, data: SessionItemData) {
	current = current.firstChild;
	while (current) {
		if (current.isEnabled(data) && !current.isCompleted(data)) {
			return false;
		}
		current = current.nextSibling;
	}
	return true;
}

export class NavTreeNode implements INavTreeNode {

	parent: INavTreeNode | null = null;
	prevSibling: INavTreeNode | null = null;
	nextSibling: INavTreeNode | null = null;
	firstChild: INavTreeNode | null = null;
	lastChild: INavTreeNode | null = null;
	isProcedure = false;
	isProlog = false;
	isEpilog = false;
	isQuestionGroup = false;
	requiredDevices: string[];

	isEnabled: (data: SessionItemData) => boolean = () => !!this.firstChild;
	isCompleted: (data: SessionItemData) => boolean = (data) => areChildrenCompleted(this, data);

	constructor(public readonly urlPrefixes: string[]) {
	}

	setChildren(children: INavTreeNode[]): NavTreeNode {
		children.forEach((navGroup, index) => {
			navGroup.parent = this;
			navGroup.prevSibling = children[index - 1] || null;
			navGroup.nextSibling = children[index + 1] || null;
		});
		if (children.length) {
			this.firstChild = children[0] || null;
			this.lastChild = children[children.length - 1] || null;
		}
		return this;
	}

}


export class WizardPageTreeNode extends NavTreeNode {

	isEnabled: (data: SessionItemData) => boolean = () => true;

	constructor(urlPrefixes: string[], public readonly page: WizardPage) {
		super(urlPrefixes);
	}

	setChildren(): NavTreeNode {
		throw Error('WizardPageTreeNode should not have children');
	}

}
